import Gradient from './gradient';
import './gsap';
import './header';

// Configuration
const gradientColors = ['#575bbc', '#b4b4f4', '#9ca5e8', '#28214a', '#2f307a'];

// Initialize all functions independently
document.addEventListener('DOMContentLoaded', function () {
	initializeHeaderStyling();
	initializeFrontpageGradient();
	initializeGradientRows();
	initializeHeadingGradients();
	initializeDebugMode();
});

/**
 * Initialize header styling
 */
function initializeHeaderStyling() {
	const header = document.querySelector('header .fl-row-content');
	if (header) {
		header.style.position = 'relative';
		header.style.zIndex = '1';
	}
}

/**
 * Initialize frontpage gradient
 */
function initializeFrontpageGradient() {
	const hero = document.querySelector('.fl-node-9udbamne5287 .fl-row-content-wrap');
	if (!hero) return;

	const frontpageGradient = new Gradient(
		gradientColors,
		150,
		{
			wireframe: true,
		},
		{
			noiseX: 2.75,
			noiseY: 4.47,
			cameraPosition: { x: -0.18, y: 0.41, z: 0.59 },
			cameraRotation: { x: 0.34, y: -0.18, z: 0.23 },
			seed: 50,
		}
	);

	const canvas = frontpageGradient.canvas();
	canvas.style.position = 'absolute';
	canvas.style.top = 0;
	canvas.style.left = 0;
	canvas.style.width = '100%';
	canvas.style.height = '100%';
	canvas.style.pointerEvents = 'none';

	hero.prepend(canvas);

	const sibling = canvas.nextElementSibling;
	if (sibling) {
		sibling.style.position = 'relative';
	}

	// Store gradient reference for debug mode
	window.frontpageGradient = frontpageGradient;
}

/**
 * Initialize gradient rows
 */
function initializeGradientRows() {
	const gradientRows = document.querySelectorAll('.fl-node-v1xmiltzup02, .gradient-row');

	gradientRows.forEach((row) => {
		row.style.position = 'relative';

		const child = row.children[0];
		if (child) {
			row.style.background = window.getComputedStyle(child).background;
			child.style.background = 'transparent';
		}

		const gradient = new Gradient(
			gradientColors,
			150,
			{
				wireframe: false,
			},
			{
				noiseX: 2.38,
				noiseY: 2.99,
				cameraPosition: { x: -0.67, y: -0.16, z: 0.42 },
				cameraRotation: { x: 0.24, y: -0.35, z: -0.06 },
				seed: 2341,
			}
		);

		const canvas = gradient.canvas();
		canvas.style.position = 'absolute';
		canvas.style.bottom = 0;
		canvas.style.left = 0;
		canvas.style.width = '100%';
		canvas.style.height = '100%';
		canvas.style.pointerEvents = 'none';

		row.prepend(canvas);

		if (window.location.href.includes('debug')) {
			gradient.enableDebug();
		}
	});
}

/**
 * Initialize heading gradients
 */
function initializeHeadingGradients() {
	const gradientHeadings = document.querySelectorAll('.fl-heading[data-type="white-purple-gradient"]');
	const darkPurpleLightPurpleGradientHeadings = document.querySelectorAll(
		'.fl-heading[data-type="dark-purple-light-purple-gradient"]'
	);

	gradientHeadings.forEach((heading) => {
		const intensity = heading.getAttribute('data-gradient-intensity');
		if (intensity) {
			heading.style.setProperty('--gradient-intensity', intensity + '%');
		}
	});

	darkPurpleLightPurpleGradientHeadings.forEach((heading) => {
		const intensity = heading.getAttribute('data-gradient-intensity');
		if (intensity) {
			heading.style.setProperty('--gradient-intensity', intensity + '%');
		}
	});
}

/**
 * Initialize debug mode
 */
function initializeDebugMode() {
	if (window.location.href.includes('debug') && window.frontpageGradient) {
		window.frontpageGradient.enableDebug();
	}
}
